export default "__VITE_ASSET__DSY_Qndu__"